
import { defineComponent } from "vue";
import { usePanelStore } from "@/stores/panelStore";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layoutStore";
import { useApiStore } from "@/stores/apiStore";
import { useSiteStore } from "@/stores/siteStore";
import PanelContainer from "@/components/panels/container.vue";
import { useViewStore } from "@/stores/ssaStore/views";
import { useWslinkStore } from "@/stores/ssaStore/wslink";
import { useSsaStore } from "@/stores/ssaStore";
import { useActiveStore } from "@/stores/ssaStore/active";
import Toolbelt from "./toolbelt.vue";
export default defineComponent({
	name: "imdex-visualizer-container",
	setup() {
		const panelStore = usePanelStore();
		const views = useViewStore();
		const api = useApiStore();
		const layoutStore = useLayoutStore();
		const wsLink = useWslinkStore();
		const siteStore = useSiteStore();
		const { ready } = storeToRefs(panelStore);
		const { connected } = storeToRefs(wsLink);
		const { isDragging, toolbeltPos } = storeToRefs(layoutStore);
		const { SSA_UPDATE_ACTIVE_SCALARBAR: updateActiveScalarBar } = useSsaStore();
		const { SSA_ACTIVE_LAYER: activeLayer, SSA_ACTIVE_VIEW: activeView } = storeToRefs(
			useActiveStore()
		);
		return {
			activeLayer,
			activeView,
			updateActiveScalarBar,
			connected,
			ready,
			wsLink,
			views,
			isDragging,
			toolbeltPos,
			panelStore,
			api,
			siteStore
		};
	},
	data() {
		return {
			showVis: false,
			initialViewId: 0
		};
	},
	props: {
		componentState: {
			type: Object,
			default: () => {
				return { flex: 1, lastFlex: 1 };
			}
		}
	},
	components: {
		PanelContainer,
		Toolbelt
	},
	mounted() {
		this.resizeContainer();
		if (this.ready) {
			if (localStorage.getItem("v-layout") != null) {
				this.setPanelLayout(JSON.parse(localStorage.getItem("v-layout") || ""));
			} else {
				this.setPanelLayout(this.layout);
			}
		}
	},
	methods: {
		setPanelLayout(payload: any) {
			this.panelStore.SET_PANEL_LAYOUT(payload);
		},
		resizeContainer() {
			this.$nextTick(() => {
				const ro = new ResizeObserver(() => {
					if (this.$refs.panelContainer != null) {
						(this.$refs.panelContainer as any).redrawHandles();
					}
				});

				// Observe one or multiple elements
				ro.observe(this.$refs.main as any);
			});
		}
	},
	watch: {
		activeView() {
			this.updateActiveScalarBar();
		},
		activeLayer() {
			this.updateActiveScalarBar();
		},
		initialViewId() {
			this.showVis = true;
		},
		ready: {
			deep: true,
			handler(v) {
				if (v) {
					if (localStorage.getItem("v-layout") != null) {
						this.setPanelLayout(JSON.parse(localStorage.getItem("v-layout") || ""));
					} else {
						this.setPanelLayout(this.layout);
					}
				}
			}
		},
		panelLayout: {
			deep: true,
			handler(v) {
				localStorage.setItem("v-layout", JSON.stringify(v));
			}
		}
	},
	computed: {
		panelLayout() {
			return this.panelStore.panelLayout;
		},
		layout() {
			return {
				componentName: "root",
				type: "root",
				id: 3424,
				componentState: {
					flex: 1,
					lastFlex: 1
				},
				children: [
					{
						id: 522,
						componentName: "",
						type: "stacked",
						componentState: {
							flex: 1,
							lastFlex: 1
						},
						children: [
							{
								id: 23135,
								componentName: "3D View",
								type: "component",
								component: "Visualizer",
								componentState: {
									viewId: this.views.viewIds[0] || -1,
									flex: 1,
									color: "#fff",
									lastFlex: 1
								}
							}
						]
					}
				]
			};
		}
	}
});
